import Drawer from "@material-ui/core/Drawer";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { ICON } from "../../assets";
import confs from "../../configurations";
import { price, round2 } from "../../utils";
import { getPricesSteps } from "../../utils_price";
import { useAuth } from "../Auth/useAuth";
import CurrentCart from "../Carts/CurrentCart";
import { useCart } from "../Carts/useCart";
import useTranslations from "../Translations/useTranslations";
import UiButton, { UI_BUTTON_TYPE } from "../ui/UiButton";
import UiIcon from "../ui/UiIcon";
import UiTag from "../ui/UiTag";
import { UI_TAG_TYPE } from "../ui/UiTag/index";
import ArticleCard from "./ArticleCard";
import "./ArticlesList.css";

const { URL_GED } = confs;

function ArticlesList({
  gen_articles,
  closeModal,
  selected_criteres,
  isPack = false,
}) {
  const [selectedArt, selectArt] = useState();
  const [auth] = useAuth();
  const trl = useTranslations();

  const [{ current_cart }, cartSDK] = useCart(auth.user.client_profile?.id);
  const [cartModalOpened, setCartModalOpened] = useState(false);
  const [currentCart, setCurrentCart] = useState([]);
  const [certificateInfo, setCertificateInfo] = useState(false);
  const [packCount, setPackCount] = useState(0);
  const [packCurrentQuantity, updatePackQuantity] = useState(0);

  const formatTitle = (title) => {
    if (!title) return "";
    return title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
  };
  const libgen = trl.data.message(
    "GEN",
    "CODGEN",
    gen_articles.CODGEN,
    "LIBGEN",
  );

  useEffect(() => {
    if (isPack) {
      const packInCart = current_cart.packs.find(
        (pack) => pack.name === libgen,
      );
      setPackCount((packInCart && packInCart.qte_commande) || 0);
      updatePackQuantity((packInCart && packInCart.qte_commande) || 0);
    }
  }, [current_cart]);

  const _addToLocalCart = (article, qte_commande) => {
    let _cart = currentCart;
    let index = _cart.findIndex((art) => art.article.CODART === article.CODART);

    let remise =
      article.REMISE_FIXE > 0
        ? article.REMISE_FIXE
        : article.groupe_tarifaire.REMISE_FIXE > 0
          ? article.groupe_tarifaire.REMISE_FIXE
          : null;

    if (!remise || (!!remise && remise <= 0)) {
      if (
        article.groupe_tarifaire.TRANCHE5 > 0 &&
        qte_commande >= article.groupe_tarifaire.TRANCHE5
      ) {
        remise = article.groupe_tarifaire.REMISE5;
      } else if (
        article.groupe_tarifaire.TRANCHE4 > 0 &&
        qte_commande >= article.groupe_tarifaire.TRANCHE4
      ) {
        remise = article.groupe_tarifaire.REMISE4;
      } else if (
        article.groupe_tarifaire.TRANCHE3 > 0 &&
        qte_commande >= article.groupe_tarifaire.TRANCHE3
      ) {
        remise = article.groupe_tarifaire.REMISE3;
      } else if (
        article.groupe_tarifaire.TRANCHE2 > 0 &&
        qte_commande >= article.groupe_tarifaire.TRANCHE2
      ) {
        remise = article.groupe_tarifaire.REMISE2;
      } else if (
        article.groupe_tarifaire.TRANCHE1 > 0 &&
        qte_commande >= article.groupe_tarifaire.TRANCHE1
      ) {
        remise = article.groupe_tarifaire.REMISE1;
      } else {
        remise = 0;
      }
    }

    const { pricesSteps, nbUnit, minIncrement, priceStep, priceStepRef } =
      getPricesSteps(article, qte_commande);

    const qte_unite_de_vente = qte_commande / (article.up_vte || 1);
    const price_applied = priceStep ? priceStep.price * qte_unite_de_vente : 0;

    if (index >= 0) {
      // It already there
      if (qte_commande > 0) {
        _cart[index] = {
          article,
          qte_commande,
          custom_remise: remise,
          qte_unite_de_vente,
          price_applied,
          pub: priceStep?.price || 0,
        };
      } else {
        _cart.splice(index, 1);
      }
    } else {
      _cart.push({
        article,
        qte_commande,
        custom_remise: remise,
        qte_unite_de_vente,
        price_applied,
        pub: priceStep?.price || 0,
      });
    }

    setCurrentCart(_cart);

    cartSDK.addInCart({
      creator: auth.user.client_profile?.id,
      product: {
        [libgen]: _cart.sort((item1, item2) => {
          const item1Order = item1.article.ORDRE;
          const item2Order = item2.article.ORDRE;

          if (item1Order < item2Order) return -1;
          if (item1Order > item2Order) return 1;

          return 0;
        }),
      },
    });
  };

  const _addPack = (pack, qte_commande) => {
    // Pack in cart
    const packIndex = current_cart.packs.findIndex(
      (_pack) => _pack.name === libgen,
    );
    const packs = current_cart.packs;

    if (qte_commande > 0) {
      // Update cart
      const currentPack = {
        name: libgen,
        qte_commande,
        mt_remise: pack.groupe_tarifaire.MT_REMISE,
      };

      if (packIndex >= 0) {
        packs[packIndex] = currentPack;
      } else {
        // The pack doesnt exist yet
        packs.push(currentPack);
      }
    } else {
      // Remove pack from cart
      packs.splice(packIndex, 1);
      cartSDK.addInCart({
        creator: auth.user.client_profile?.id,
        product: {
          [libgen]: [],
        },
      });

      return;
    }

    const packCart = pack.articles.map((art) => {
      let article = {
        ...art,
        ...art.article,
        groupe_tarifaire: pack.groupe_tarifaire,
        generique: pack,
        gen_in_cumul: pack.DANS_BASE_DE_CALCUL_CUMUL_CA_PLV,
      };

      let remise =
        article.REMISE_FIXE > 0
          ? article.REMISE_FIXE
          : article.groupe_tarifaire.REMISE_FIXE > 0
            ? article.groupe_tarifaire.REMISE_FIXE
            : null;

      if (!remise || remise <= 0) {
        if (
          article.groupe_tarifaire.TRANCHE5 > 0 &&
          article.QTE * qte_commande >= article.groupe_tarifaire.TRANCHE5
        ) {
          remise = article.groupe_tarifaire.REMISE5;
        } else if (
          article.groupe_tarifaire.TRANCHE4 > 0 &&
          article.QTE * qte_commande >= article.groupe_tarifaire.TRANCHE4
        ) {
          remise = article.groupe_tarifaire.REMISE4;
        } else if (
          article.groupe_tarifaire.TRANCHE3 > 0 &&
          article.QTE * qte_commande >= article.groupe_tarifaire.TRANCHE3
        ) {
          remise = article.groupe_tarifaire.REMISE3;
        } else if (
          article.groupe_tarifaire.TRANCHE2 > 0 &&
          article.QTE * qte_commande >= article.groupe_tarifaire.TRANCHE2
        ) {
          remise = article.groupe_tarifaire.REMISE2;
        } else if (
          article.groupe_tarifaire.TRANCHE1 > 0 &&
          article.QTE * qte_commande >= article.groupe_tarifaire.TRANCHE1
        ) {
          remise = article.groupe_tarifaire.REMISE1;
        } else {
          remise = 0;
        }
      }

      const { priceStep } = getPricesSteps(art, art.QTE * qte_commande);
      return {
        article,
        qte_commande: art.QTE * qte_commande,
        custom_remise: remise,
        pub: priceStep?.price || 0,
      };
    });

    cartSDK.addPackInCart({ creator: auth.user.client_profile?.id, packs });

    cartSDK.addInCart({
      creator: auth.user.client_profile?.id,
      product: {
        [libgen]: packCart,
      },
    });
  };

  useEffect(() => {
    if (
      gen_articles &&
      gen_articles.articles.length > 0 &&
      gen_articles.articles.filter(
        (a) =>
          a.article.valid === true &&
          (
            !a.article.LISTE_CODGRT_EXCLUS ||
            !a.article.LISTE_CODGRT_EXCLUS.split("¤").includes(
              "¤" + current_cart.client.CODGRT + "¤",
            ) ||
            isPack
          ).length > 0 &&
          currentCart.length === 0,
      )
    ) {
      selectArt({
        ...gen_articles.articles[0],
        ...gen_articles.articles[0].article,
      });
      setCurrentCart(current_cart.products[libgen] || []);
    }
  }, [gen_articles]);

  if (!selectedArt)
    return (
      <Container>
        {backButtonRender()}
        <div className="py-5 px-5">
          {trl.message("MainPage.Dialog.noProduct")}
        </div>
      </Container>
    );

  function backButtonRender() {
    const categorieName = formatTitle(
      trl.data.message("FAG", "CODFAG", gen_articles.CODFAG, "LIBFAG"),
    );
    return (
      <React.Fragment>
        <div
          className="articles-list-back-action"
          onClick={closeModal}
          style={{ cursor: "pointer" }}
        >
          <UiIcon icon={ICON.arrowLeftIcon} size="md" />
          <span>{categorieName} - Blancrème </span>
        </div>
      </React.Fragment>
    );
  }

  function renderCartActionButton() {
    const { mt_total, mt_total_remise_pack, cumul_plv_in_cart } =
      cartSDK.getCartData();
    const totalPrice = mt_total - mt_total_remise_pack - cumul_plv_in_cart;
    const buttonContent = () => {
      const currentPrice = price(totalPrice);
      return (
        <React.Fragment>
          <div className="cart-action-button">
            <span> {currentPrice + " €"} </span>
            <UiIcon icon={ICON.cartPlusFillIcon} alt="cart icon" size="md" />
          </div>
        </React.Fragment>
      );
    };

    return (
      <React.Fragment>
        <UiButton
          size="sm"
          content={buttonContent()}
          onClick={() => setCartModalOpened(true)}
          buttonUiType={[
            totalPrice <= 0 ? UI_BUTTON_TYPE.BG_WHITE : UI_BUTTON_TYPE.NORMAL,
          ]}
          disabled={totalPrice <= 0}
        />
        <Drawer
          open={cartModalOpened}
          anchor="right"
          onClose={() => setCartModalOpened(false)}
        >
          <CurrentCart closeCart={() => setCartModalOpened(false)} />
        </Drawer>
      </React.Fragment>
    );
  }

  function generateProductTitleHeader() {
    const productTitle = trl.data.message(
      "GEN",
      "CODGEN",
      gen_articles.CODGEN,
      "LIBGEN",
    );
    function discountTage() {
      if (!isPack) return null;
      const packageDiscount = gen_articles.groupe_tarifaire.MT_REMISE;
      if (packageDiscount > 0) {
        return (
          <UiTag
            content={
              <span className="pack-tag">
                {packageDiscount ? "-" + packageDiscount + " € " : "-0 €"}
              </span>
            }
            uiTagType={UI_TAG_TYPE.highlightColor}
          />
        );
      }
      return null;
    }
    return (
      <React.Fragment>
        {backButtonRender()}
        <div className="articles-list-product-header">
          <span className="articles-list-product-title">
            {productTitle} {discountTage()}
            {/* Some products have extra information regarding PLV.
For example: if the purchase amount is ₹200, the user will receive 5% value in PLV credits  below code is this */}
            {/* {gen_articles.DANS_BASE_DE_CALCUL_CUMUL_CA_PLV === "O" &&
              current_cart.client.groupe_tarifaire.MT_CDC_SEUIL1 > 0 && (
                <CalculatorRules />
              )} */}
          </span>
          {renderCartActionButton()}
        </div>
        <div className="separator" />
      </React.Fragment>
    );
  }

  function showProductImageAndTitle() {
    const imgSrc = `${URL_GED}/Articles/${selectedArt.CODART}/${selectedArt.CODART}-e.jpg`;
    const onError = ({ currentTarget }) => {
      currentTarget.onerror = null; // prevents looping
      currentTarget.src = "/background-picture-not-found-2.svg";
    };
    return (
      <React.Fragment>
        <div className="articles-list-product-image-and-title">
          <img
            className="articles-list-product-image"
            src={imgSrc}
            onError={onError}
            width="366px"
            height="366px"
          />
          <span className="articles-list-product-img-title">
            {" "}
            {trl.data.message("ART", "CODART", selectedArt.CODART, "LIBART")}
          </span>
        </div>
      </React.Fragment>
    );
  }

  function renderProductDescription() {
    return (
      <React.Fragment>
        <div className="articles-list-product-description">
          <div className="articles-list-product-description-title">
            Description
          </div>
          <span>
            {trl.data.message("GEN", "CODGEN", gen_articles.CODGEN, "OBSGEN")}
          </span>
          <span>{selectedArt.DESCRIPTION}</span>
        </div>
        {/* <div className="articles-list-product-description">
          <div className="articles-list-product-description-title">
            Le + Blancrème
          </div>
          <span>
            Accédez à la
            <a> plateforme e-learning (tutoriels vidéos disponibles)</a>
          </span>
          <span>
            Découvrez la<a> banque d’images</a> Blancrème
          </span>
        </div> */}
      </React.Fragment>
    );
  }

  function packControls() {
    if (!isPack) return null;
    const products = gen_articles.articles;
    const groupe_tarifaire = gen_articles.groupe_tarifaire;
    const MT_REMISE = groupe_tarifaire.MT_REMISE || 0;
    function calculatePackPrice() {
      if (packCount <= 0) return 0;

      const totalPrice =
        products.reduce((acc, product) => {
          const qte = product?.QTE || 0;
          let remise =
            product.REMISE_FIXE > 0
              ? product.REMISE_FIXE
              : groupe_tarifaire.REMISE_FIXE > 0
                ? groupe_tarifaire.REMISE_FIXE
                : null;

          if (!remise || (!!remise && remise <= 0)) {
            if (
              groupe_tarifaire.TRANCHE5 > 0 &&
              qte >= groupe_tarifaire.TRANCHE5
            ) {
              remise = groupe_tarifaire.REMISE5;
            } else if (
              groupe_tarifaire.TRANCHE4 > 0 &&
              qte >= groupe_tarifaire.TRANCHE4
            ) {
              remise = groupe_tarifaire.REMISE4;
            } else if (
              groupe_tarifaire.TRANCHE3 > 0 &&
              qte >= groupe_tarifaire.TRANCHE3
            ) {
              remise = groupe_tarifaire.REMISE3;
            } else if (
              groupe_tarifaire.TRANCHE2 > 0 &&
              qte >= groupe_tarifaire.TRANCHE2
            ) {
              remise = groupe_tarifaire.REMISE2;
            } else if (
              groupe_tarifaire.TRANCHE1 > 0 &&
              qte >= groupe_tarifaire.TRANCHE1
            ) {
              remise = groupe_tarifaire.REMISE1;
            } else {
              remise = 0;
            }
          }
          const { priceStep, nbUnit } = getPricesSteps(product, qte);
          const pub = priceStep
            ? priceStep.price / nbUnit
            : 0;
          const pubAfterRemise = pub - (pub * remise) / 100;
          return acc + pubAfterRemise * qte;
        }, 0) * packCount;
      const discount = MT_REMISE > 0 ? MT_REMISE * packCount : 0;

      return totalPrice - discount;
    }

    const discountLabel =
      MT_REMISE > 0 && packCount > 0 ? round2(MT_REMISE * packCount) : null;
    const currentPrice = price(calculatePackPrice());

    function submitConfirmation() {
      if (hasPriceOnRequestItem) return;
      _addPack(gen_articles, packCount);
    }
    function addAction() {
      setPackCount(packCount + 1);
    }
    function removeAction() {
      if (packCount - 1 < 0) return;
      setPackCount(packCount - 1);
    }

    const hasPriceOnRequestItem = gen_articles.articles.some(a => 
      !a.prices || 
      a.prices.length === 0
    );

    return (
      <React.Fragment>
        <div className="articles-list-pack-controls">
          <div className="pack-add-remove-buttons">
            {hasPriceOnRequestItem ? (
              <div 
                className="btn ui-button btn-sm" 
                style={{ cursor: 'not-allowed', backgroundColor: '#E0E0E0', color: '#9E9E9E' }}
              >
                <UiIcon icon={ICON.minusIcon} alt="minus-icon" />
              </div>
            ) : (
              <UiButton
                content={<UiIcon icon={ICON.minusIcon} alt="minus-icon" />}
                onClick={removeAction}
                disabled={packCount <= 0}
                size="sm"
              />
            )}
            <div className="pack-quantity">{packCount}</div>
            {hasPriceOnRequestItem ? (
              <div 
                className="btn ui-button btn-sm" 
                style={{ cursor: 'not-allowed', backgroundColor: '#E0E0E0', color: '#9E9E9E' }}
              >
                <UiIcon icon={ICON.plusIcon} alt="plus-icon" />
              </div>
            ) : (
              <UiButton
                content={<UiIcon icon={ICON.plusIcon} alt="plus-icon" />}
                onClick={addAction}
                size="sm"
              />
            )}
          </div>

          {discountLabel && (
            <UiTag
              content={
                <span className="pack-tag">
                  {discountLabel ? "-" + discountLabel + " € " : "-0 €"}
                </span>
              }
              uiTagType={UI_TAG_TYPE.highlightColor}
            />
          )}

          {currentPrice && packCount > 0 && !hasPriceOnRequestItem && (
            <div className="pack-price">
              <UiIcon
                icon={ICON.confirmationPinkIcon}
                alt="confirmation-pink-icon"
                size="md"
              />
              <span>{currentPrice} €</span>
            </div>
          )}
          {hasPriceOnRequestItem ? (
            <div 
              className="btn ui-button btn-md m-2" 
              style={{ 
                display: 'block', 
                cursor: 'not-allowed',
                backgroundColor: '#E0E0E0',
                color: '#9E9E9E',
                textAlign: 'center',
                padding: '10px 20px',
                borderRadius: '4px',
                fontWeight: '600'
              }}
            >
              Prix sur demande - Rajouter en commentaire
            </div>
          ) : (
            <UiButton
              content={"Ajouter au panier"}
              onClick={submitConfirmation}
              size="md"
              disabled={packCurrentQuantity === packCount}
              classNames={["m-2"]}
              style={{
                display:
                  (packCurrentQuantity === 0 && packCount === 0) ? "none" : "block",
              }}
            />
          )}
        </div>
      </React.Fragment>
    );
  }

  function renderProductList() {
    if (!gen_articles) return null;
    const productsList = gen_articles.articles.map((art, key) => {
      if (isPack) return art;

      if (selected_criteres && art) {
        let hasCritere = false;
        if (selected_criteres.critere_1) {
          hasCritere = true;
          const regexpCR1 = new RegExp(selected_criteres.critere_1);
          if (art.article.CODCR1.match(regexpCR1)) return art;
        }
        if (selected_criteres.critere_2) {
          hasCritere = true;
          const regexpCR2 = new RegExp(selected_criteres.critere_2);
          if (art.article.CODCR2.match(regexpCR2)) return art;
        }
        if (selected_criteres.critere_3) {
          hasCritere = true;
          const regexpCR3 = new RegExp(selected_criteres.critere_3);
          if (art.article.CODCR3.match(regexpCR3)) return art;
        }

        if (
          !hasCritere &&
          !!art.article.valid &&
          (!art.article.LISTE_CODGRT_EXCLUS ||
            !art.article.LISTE_CODGRT_EXCLUS.split("¤").includes(
              current_cart.client.CODGRT,
            ))
        )
          return art;
      }
    });

    const renderProductList = () =>
      productsList.map((art, key) => {
        if (!art) return null;
        return (
          <React.Fragment key={key}>
            <div className={`product-card ${isPack ? "product-pack" : ""}`}>
              <ArticleCard
                article={art}
                groupe_tarifaire={gen_articles.groupe_tarifaire}
                gen_in_cumul={gen_articles.DANS_BASE_DE_CALCUL_CUMUL_CA_PLV}
                current_cart={currentCart}
                addToLocalCart={_addToLocalCart}
                selectArt={selectArt}
                generique={gen_articles}
                isPack={isPack}
                selectedArt={selectedArt}
              />
            </div>
          </React.Fragment>
        );
      });

    return <React.Fragment>{renderProductList()}</React.Fragment>;
  }

  function renderProductDetails() {
    return (
      <React.Fragment>
        <div className="articles-list-product-details">
          <div className="articles-list-product-info">
            {renderProductDescription()}
            {showProductImageAndTitle()}
          </div>
          <div className="articles-list-product-sub">
            <div
              className={`articles-list-sub-list ${isPack ? "pack-height" : "normal-height"
                }`}
            >
              {renderProductList()}
            </div>
            {packControls()}
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div style={{ margin: "0 6%" }}>
        {generateProductTitleHeader()}
        {renderProductDetails()}
      </div>
    </React.Fragment>
  );
}

export default ArticlesList;
